

















































































































































import Vue from 'vue'
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import moment from 'moment'
import { ProductPricePayload, UpsertProductPricePayload } from '@/types/payload'
import NumberField from '@/components/NumberField.vue'


interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  validationRules: Array<Function>
  numberRules: Array<Function>
  decimalRules: Array<Function>
  dateRulesNotEmpty: Array<Function>
  dateRules: Array<Function>

  gridData: any[]
  selectedPriceId: number | null

  Preisart: any
  GueltigVon: any
  GueltigVonFormatted: any
  GueltigBis: any
  GueltigBisFormatted: any
  Art: any
  DateFilter: any
  DateFilterFormatted: any
  Preis: number
  Waehrung: any
  Preiseinheit: any
  Rabatt: any
  Steuer: any
}

export default Vue.extend({
  name: 'ProductPrice',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    NumberField
  },

  props: {
    productId: Number,
    selectedLagerungenId: Number,
    storageMetaData: Object as () => any,
    storageData: Object as () => any,
    isCreate: Boolean,
    isUpdate: Boolean,
    loading: Boolean
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''
    const numberRule = (value: any): boolean | string => (value >= 0) || ''

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      validationRules: [required],
      numberRules: [numberRule],
      decimalRules: [
        (value: string) => {
          const pattern = /^$|^(\d+(?:[\.\,]\d{1,5})?)$/
          return pattern.test(value) || this.$t('badValue')
        }
      ],
      dateRulesNotEmpty: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value && value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        },

        required
      ],
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value && value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],

      gridData: [],
      selectedPriceId: null,

      Preisart: null,
      GueltigVon: null,
      GueltigVonFormatted: null,
      GueltigBis: null,
      GueltigBisFormatted: null,
      Art: null,
      DateFilter: null,
      DateFilterFormatted: null,
      Preis: 0.000,
      Waehrung: null,
      Preiseinheit: null,
      Rabatt: null,
      Steuer: null,
    }
  },

  watch: {
    isCreate (newVal: boolean): void {
      if(newVal) {
        this.selectedPriceId = null
        //@ts-ignore
        this.$refs.dataGrid.instance.selectRows([])
        this.$emit('setPriceId', this.selectedPriceId)
        this.resetData()

        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    isUpdate (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    storageData (newVal: any): void {
      if(newVal) {
        this.setData()
      }
    },

    GueltigVonFormatted (newVal: string): void {
      if(newVal && newVal.length > 0) {
        this.GueltigVon = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.GueltigVon = null
      }
    },

    GueltigBisFormatted (newVal: string): void {
      if(newVal && newVal.length > 0) {
        this.GueltigBis = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.GueltigBis = null
      }
    },

    DateFilterFormatted (newVal: string | null): void {
      if(newVal && newVal.length > 0) {
        this.DateFilter = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.DateFilter = null
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getFilteredGridData (): any[] {
      if(this.DateFilter) {
        return this.gridData.filter((item: any) => moment(this.DateFilter).isBetween(moment(item.GueltigVon), moment(item.GueltigBis), 'day', '[]'))
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    formatNumber(value: number | null, digital: number): any {
      if(value !== null) {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: digital,
          maximumFractionDigits: digital
        }).format(value)
      } else {
        return ''
      }
    },

    onPreisChange (): void {
      if(this.Preis == null || this.Preis < 0) {
        this.Preis = 0.000
      }
    },

    getPreisartLabel (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Preisarten.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    getWaehrungCode (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Waehrungen.find((item: any) => item.ID === id)
      return foundItem ? foundItem.ISOCode : ''
    },

    getRabattCode (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Rabattsaetze.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Code : ''
    },

    getSteuerCode (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Steuersaetze.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Code : ''
    },

    getFormattedDate (item: string | null): string {
      return item ? moment(item).format('DD.MM.YYYY') : ''
    },

    getArtLabel (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.PreiseArt.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    getArtCode (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.PreiseArt.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Code : ''
    },

    getPreisartCode (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Preisarten.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Code : ''
    },

    getWaehrungLabel (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Waehrungen.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    getRabattLabel (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Rabattsaetze.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    getSteuerLabel (id: number): string {
      const foundItem: any | undefined = this.storageMetaData.Steuersaetze.find((item: any) => item.ID === id)
      return foundItem ? foundItem.Bezeichnung : ''
    },

    onGueltigVonChange (date: string): void {
      if(date && date.length > 0) {
        this.GueltigVonFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.GueltigVonFormatted = null
      }
    },

    onGueltigBisChange (date: string): void {
      if(date && date.length > 0) {
        this.GueltigBisFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.GueltigBisFormatted = null
      }
    },

    onDateFilterChange (date: string): void {
      if(date && date.length > 0) {
        this.DateFilterFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.DateFilterFormatted = null
      }
    },

    onRowClick (data: any): void {
      this.selectedPriceId = data.data.ID
      this.$emit('setPriceId', data.data.ID)

      this.Preisart = data.data.Preisart
      this.GueltigVon = data.data.GueltigVon
      this.GueltigVonFormatted = data.data.GueltigVon ? moment(data.data.GueltigVon).format('DD.MM.YYYY') : null
      this.GueltigBis = data.data.GueltigBis
      this.GueltigBisFormatted = data.data.GueltigBis ? moment(data.data.GueltigBis).format('DD.MM.YYYY') : null
      this.Art = data.data.Art
      this.Preis = parseFloat(parseFloat(data.data.Preis).toFixed(3))
      this.Waehrung = data.data.Waehrung
      this.Preiseinheit = data.data.Preiseinheit
      this.Rabatt = data.data.Rabatt
      this.Steuer = data.data.Steuer
    },

    onCancelClick (): void {
      this.setData()
      this.$emit('onCancelClick')
    },

    upsertProductPrice (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        if (this.isCreate) {
          const payloadData: ProductPricePayload = {
            ID: 0,
            Lagerung: this.selectedLagerungenId,
            Preisart: this.Preisart,
            Preis: this.Preis,  //double
            Waehrung: this.Waehrung,
            Rabatt: this.Rabatt,
            Steuer: this.Steuer,
            GueltigVon: this.GueltigVon,
            GueltigBis: this.GueltigBis,
            Art: this.Art,
            Preiseinheit: this.Preiseinheit
          }

          let payload: UpsertProductPricePayload = {
            Data: {
              Price: payloadData
            }
          }
          this.$emit('upsertProductPrice', payload)
        } else if (this.isUpdate) {
          const payloadData: ProductPricePayload = {
            ID: this.selectedPriceId!,
            Lagerung: this.selectedLagerungenId,
            Preisart: this.Preisart,
            Preis: this.Preis,  //double
            Waehrung: this.Waehrung,
            Rabatt: this.Rabatt,
            Steuer: this.Steuer,
            GueltigVon: this.GueltigVon,
            GueltigBis: this.GueltigBis,
            Art: this.Art,
            Preiseinheit: this.Preiseinheit
          }

          let payload: UpsertProductPricePayload = {
            Data: {
              Price: payloadData
            }
          }
          this.$emit('upsertProductPrice', payload)
        }
      }
    },

    setData (): void {
      this.gridData =  _.orderBy(this.storageData.Preise, 'GueltigVon', 'desc')

      if(this.getFilteredGridData && this.getFilteredGridData[0]) {
        this.selectedPriceId = this.getFilteredGridData[0].ID
        this.$emit('setPriceId',  this.selectedPriceId)
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedPriceId])}, 100)
      }

      this.Preisart = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Preisart : null
      this.GueltigVon = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].GueltigVon : null
      this.GueltigVonFormatted = this.storageData && this.storageData.Preise[0] && this.storageData.Preise[0].GueltigVon ? moment(this.storageData.Preise[0].GueltigVon).format('DD.MM.YYYY') : null
      this.GueltigBis = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].GueltigBis : null
      this.GueltigBisFormatted = this.storageData && this.storageData.Preise[0] && this.storageData.Preise[0].GueltigBis ? moment(this.storageData.Preise[0].GueltigBis).format('DD.MM.YYYY') : null
      this.Art = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Art : null
      this.Preis = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Preis !== null ? parseFloat(parseFloat(this.storageData.Preise[0].Preis).toFixed(3)) : 0.000 : 0.000
      this.Waehrung = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Waehrung : null
      this.Preiseinheit = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Preiseinheit : null
      this.Rabatt = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Rabatt : null
      this.Steuer = this.storageData && this.storageData.Preise[0] ? this.storageData.Preise[0].Steuer : null

      const form: any = this.$refs['form']
      form.resetValidation()
    },

    resetData (): void {
      this.Preisart = null
      this.GueltigVon = moment().format('YYYY-MM-DD')
      this.GueltigVonFormatted = moment().format('DD.MM.YYYY')
      this.GueltigBis = moment().format('YYYY-MM-DD')
      this.GueltigBisFormatted = moment().format('DD.MM.YYYY')
      this.Art = null
      this.Preis = 0.000
      this.Waehrung = this.storageMetaData.Waehrungen && this.storageMetaData.Waehrungen[0] ? this.storageMetaData.Waehrungen[0].ID : null
      this.Preiseinheit = 1
      this.Rabatt = this.storageMetaData.Rabattsaetze && this.storageMetaData.Rabattsaetze[0] ? this.storageMetaData.Rabattsaetze[0].Rabatt : null
      this.Steuer = this.storageMetaData.Steuersaetze && this.storageMetaData.Steuersaetze[0] ? this.storageMetaData.Steuersaetze[0].Steuer : null

      const form: any = this.$refs['form']
      form.resetValidation()
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    this.setData()
  }

})
